import { types, Instance } from "mobx-state-tree";
import { ValidationMesssageModel } from "../ValidationMesssage";
import { ValidatorModel } from "../Validator";
import { RequiredValidatorModel } from "../required/RequiredValidator";

export const EmailModel = types.model({
  isRequired: types.boolean,
  requiredValidator: types.optional(RequiredValidatorModel, {}),
});

export const EmailValidatorModel = types.compose(EmailModel, ValidatorModel).actions((self) => {
  const validateEmail = (value: any) => {
    return RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/).test(
      value
    )
      ? undefined
      : ValidationMesssageModel.create({
          message: { mainKey: "general.validation.email" },
        });
  };

  return {
    validate(value: string) {
      if (self.isRequired) {
        const result = self.requiredValidator.validate(value);
        if (result && result.message.mainKey) return result;
      }

      return validateEmail(value);
    },
  };
});

export type EmailValidator = Instance<typeof EmailValidatorModel>;
